import { PostCardStack } from './post-card-stack';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { TheWoodsPostCardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/post-cards-4x6/the-woods-post-card-background/the-woods-post-card-background.component';
import type { TheWoodsCardData } from '../../../../print-cards/the-woods-card-data';
import { TheWoodsPostCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/post-cards-4x6/the-woods-post-card-stack-content/the-woods-post-card-stack-content.component';

export class TheWoodsPostCardStack extends PostCardStack {
  override getCardBackgroundComponent(cardData: TheWoodsCardData): Type<CardBackgroundComponent> | null {
    return TheWoodsPostCardBackgroundComponent;
  }

  override getCardContentComponent(cardData: TheWoodsCardData): Type<PrintCardContentComponent> | null {
    return TheWoodsPostCardStackContentComponent;
  }

  override getCardWidthInInches(): number {
    return 7;
  }

  override getCardHeightInInches(): number {
    return 4.5;
  }

  /**
   * We don't need a bleed border, because color strips never touch.
   */
  override nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
